// src/components/Common/FeatureLockedState.tsx
// v2.0 - Retrocompatible & Enhanced for Prediction Dashboard
import React from 'react';
import { Box, Typography, Button, Paper, Stack} from '@mui/material';
import { Link } from 'react-router-dom';
import { useBackTarget } from '../../modules/pricingJourney/navigation';
import LockIcon from '@mui/icons-material/Lock';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface FeatureLockedStateProps {
  // Soporte dual para no romper usos anteriores
  title?: string;       // Nuevo estándar
  featureName?: string; // Legacy (BatchOptimization usa esto)
  
  description: string;
  features?: string[];  // Nueva lista opcional de capacidades
}

const FeatureLockedState: React.FC<FeatureLockedStateProps> = ({ 
  title, 
  featureName, 
  description,
  features 
}) => {
  // PRC-027: «Volver» al origen; sin origen, a Overview (el Dashboard se retiró).
  const back = useBackTarget('/margin-center/overview', 'Volver a Overview');
  // Determinamos el título a mostrar (Prioridad: title > featureName)
  const displayTitle = title || featureName || "Funcionalidad Bloqueada";

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', p: 2 }}>
      <Paper 
        elevation={0} 
        sx={{ 
          p: 5, 
          textAlign: 'center', 
          maxWidth: 550, 
          width: '100%',
          borderRadius: 4,
          bgcolor: '#1e293b', // Slate 800
          border: '1px solid #334155',
          color: 'white'
        }}
      >
        <Box sx={{ mb: 3, display: 'inline-flex', p: 2, borderRadius: '50%', bgcolor: 'rgba(56, 189, 248, 0.1)' }}>
          <LockIcon sx={{ fontSize: 48, color: '#38bdf8' }} />
        </Box>
        
        <Typography variant="h4" fontWeight="800" gutterBottom sx={{ color: '#f8fafc' }}>
          {displayTitle}
        </Typography>
        
        <Typography variant="body1" color="#94a3b8" paragraph sx={{ mb: 4, lineHeight: 1.6 }}>
          {description}
        </Typography>

        {/* Lista de Features (Solo se renderiza si se pasa la prop) */}
        {features && features.length > 0 && (
          <Box sx={{ mb: 4, textAlign: 'left', bgcolor: 'rgba(15, 23, 42, 0.5)', p: 3, borderRadius: 2 }}>
            <Stack spacing={2}>
              {features.map((feat, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                   <CheckCircleIcon sx={{ color: '#38bdf8', fontSize: 20 }} />
                   <Typography variant="body2" sx={{ color: '#cbd5e1' }}>{feat}</Typography>
                </Box>
              ))}
            </Stack>
          </Box>
        )}

        <Button 
          component={Link} 
          to="/subscription"
          variant="contained" 
          size="large" 
          fullWidth
          sx={{ 
            borderRadius: 2, 
            py: 1.5, 
            fontWeight: 'bold',
            bgcolor: '#38bdf8',
            color: '#0f172a',
            '&:hover': { bgcolor: '#0ea5e9' }
          }}
        >
          Ver planes
        </Button>
        
        <Button 
          onClick={back.go}
          sx={{ mt: 2, textTransform: 'none', color: '#64748b', '&:hover': { color: '#94a3b8' } }}
        >
          {back.label}
        </Button>
      </Paper>
    </Box>
  );
};

export default FeatureLockedState;